import { post } from "./lib/api"

export function createSsoCallbackUrl(callbackUrl, urlOption) {
  let ssoCallbackUrl = callbackUrl
  const params = Object.entries(urlOption || {})
  if (params.length) {
    ssoCallbackUrl += (callbackUrl.includes("?") ? "&" : "?") + new URLSearchParams(params)
  }
  return ssoCallbackUrl
}

export async function applePost(ssoCallbackUrl, data) {
  try {
    return post(ssoCallbackUrl, data).then(response => {
      if (response.redirect) {
        window.location.assign(response.redirect)
      }
    })
  } catch (error) {
    throw new Error("Your Apple ID authentication failed.", { cause: error })
  }
}

export function facebookSSO(callbackUrl, urlOption, callbackOptions = {}) {
  const options =
    callbackOptions && typeof callbackOptions === "object" ? callbackOptions : {}
  const ssoCallbackUrl = createSsoCallbackUrl(callbackUrl, urlOption)
  const opts = { scope: "email" }
  if (options.fbReauth) {
    opts.auth_type = "rerequest"
  }

  return new Promise((resolve, reject) =>
    FB.login(function (response) {
      if (response.authResponse) {
        resolve(post(ssoCallbackUrl, options))
      } else {
        const ssoErrorMessage = "Facebook could not verify your account."

        reject(new Error(ssoErrorMessage))
      }
    }, opts)
  )
}
